import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

const fileName = 'PostWithRememberUserService';

@Injectable({
  providedIn: 'root'
})
export class PostWithRememberUserService {
  loginAuthRememberMeHeader = new HttpHeaders({
    'Content-Type': 'application/vnd.pingidentity.rememberDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  });

  constructor(
    private utils: UtilService,
    private exceptionTracking: ExceptionTrackingService
  ) {}

  async postWithRememberUser(
    authConfig: OauthAEMConfig,
    flowIdValue: string | undefined,
    userInputFields?: ILoginUserNamePasswordInput
  ): Promise<LoginAuthWithCredentials> {
    let body: PostWithCredentials = {};
    let loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams;
    try {
      let rememberMe = false;
      rememberMe =
        userInputFields?.rememberMe === 'Y' ||
        userInputFields?.persistentLogin === 'Y'
          ? true
          : false;
      body = {
        rememberUser: rememberMe
      };
      loginAuthWithCredentialsParams = {
        oauthConfig: authConfig,
        flowId: flowIdValue
      };
      return await this.utils.loginAuthWithCredResponse(
        loginAuthWithCredentialsParams,
        body,
        this.loginAuthRememberMeHeader
      );
    } catch (exception) {
      const exceptionMetadata: IExceptionMetadata = {
        fileName,
        methodName: 'postWithRememberUser',
        exceptionCategory: EXCEPTION_CATEGORY_ENUM.JS_CATCH_BLOCK,
        exceptionMessage:
          'Exception caught while calling PostWithRememberUserService'
      };
      const exceptionStr = exception as string;
      this.exceptionTracking.track(exceptionStr, exceptionMetadata);
      return exception as LoginAuthWithCredentials;
    }
  }
}
